import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Typography, Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  seperator: (props) => ({
    display: 'flex',
    '& p': {
      color: theme.palette.common.inputBorder,
    },
    '& hr': {
      width: props.hrWidth || '100px',
      border: `0.5px solid ${theme.palette.common.inputBorder}`,
    },
  }),
}));

const TextHr = (props) => {
  const classes = useStyles(props);
  return (
    <div className={classes.seperator}>
      <Grid container spacing={4} alignItems="center" justify="center">
        <Grid item>
          <hr />
        </Grid>
        <Grid item>
          <div>
            <Typography>{props.text}</Typography>
          </div>
        </Grid>
        <Grid item>
          <hr />
        </Grid>
      </Grid>
    </div>
  );
};

TextHr.propTypes = {
  text: PropTypes.string.isRequired,
  hrWidth: PropTypes.string,
};

export default TextHr;
